import { useState } from 'react';

import { ErrorContext } from './errorContextValue';

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [error, setError] = useState<{ statusCode: number } | null>(null);

  return (
    <ErrorContext.Provider value={{ error, setError }}>
      {children}
    </ErrorContext.Provider>
  );
};
